import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import SearchHeader from '../Search/Search'
import Flex from '../Flex/Flex'
import UserTopBar from '../UserTopBar/UserTopBar'
import styles from './topbar.module.scss'

const Topbar = (props) => {
  const profile = useSelector((state) => state.currentUserReducer.profile)

  const { hiddenSearch } = props
  const headerStyle = classnames(styles.header, {
    [styles.itemJustifyEnd]: hiddenSearch
  })

  return (
    <header className={headerStyle}>
      {!hiddenSearch && <SearchHeader />}
      {profile && (
        <Flex alignItems="center" margin="0px 0px 0px 10px">
          <UserTopBar
            name={profile.name}
            profileImageUrl={profile.profileImageUrl}
          />
        </Flex>
      )}
    </header>
  )
}

Topbar.defaultProps = {
  hiddenSearch: false
}

Topbar.propTypes = {
  hiddenSearch: PropTypes.bool
}

export default Topbar
